import styled from 'styled-components';
import PowerBackupIconSvg from '../../assets/hotels/amenities/power-backup.svg';

const PowerBackupIcon = styled(PowerBackupIconSvg as React.SFC<React.SVGProps<SVGSVGElement>>)`
  width: ${props => props.width || '1.5rem'};
  height: ${props => props.height || '1.5rem'};
  fill: ${props => props.fill || props.theme.colors.downriver.medium};
  margin: ${props => props.margin};
  cursor: pointer;
`;

export default PowerBackupIcon;
